// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"25306f37","185":"450805af","261":"06745219","602":"0076d337","608":"99f726a1","738":"7baaaad1","879":"ebb5a3d2","882":"1d7446ef","957":"5ac82f71","968":"030d04fa"}[chunkId] + ".chunk.js";
};